import React from "react";
import { t } from "../utils/i18n";
import { CVButton, Greeting, Status } from "../styles/home";
import ProfileImg from "../assets/profile.png";
import SendIcon from "@mui/icons-material/Send";
import { Link } from "react-router-dom";
import { AboutContainer, ProfileAboutPic } from "../styles/about";
import Skill from "components/skills";
import ResumeSection from "../components/resume";
import { BackgroundAnimation } from "components/backgroundAnimation";
import { ExperienceComponent } from "components/experienceComponent";

const About = () => {
  return (
    <div>
      <BackgroundAnimation />
      <AboutContainer>
        <ProfileAboutPic
          src={ProfileImg}
          // style={{ maxWidth: "700px", maxHeight: "700px" }}
        />

        <Greeting>
          <h1>
            I'm Ilyosjon Inomjonov, <br /> full-stack web-developer.
          </h1>
          <p>
            {t("label.paragraph.first")}
            <br /> <br />
            {t("label.paragraph.second")}
          </p>
          <p>
            <Status></Status> Available for Freelancing
          </p>
          <Link style={{ textDecoration: "none" }} to={"/contact"}>
            <CVButton style={{ maxWidth: "170px" }}>
              <p>
                Get in touch{" "}
                <div style={{ transform: "rotate(0deg)" }}>
                  <SendIcon />
                </div>
              </p>
            </CVButton>
          </Link>
        </Greeting>
      </AboutContainer>
      <Skill />
      <ExperienceComponent />
    </div>
  );
};

export default About;
